import { DropdownField, FieldNode } from '@modusign/react-signing/types';
import { DeepReadonly } from 'ts-essentials';

import {
  MAX_OPTION_COUNT,
  validateDropdownFieldOptions,
} from '@app/features/apply-react-signing/libs/validations/validateDropdownFieldOptions';
import { getFieldsDataLabelErrors } from '@app/libs/fields/getFieldsDataLabelErrors';

export function getFieldsErrorMessage(fields: DeepReadonly<FieldNode[]>): string | null {
  const dropdownErrors = fields
    .filter((field): field is DropdownField => field.type === 'DROPDOWN')
    .map((field) => validateDropdownFieldOptions(field.config.options));

  if (dropdownErrors?.includes('NO_OPTION')) {
    return '드롭다운에 옵션이 입력되지 않았습니다.';
  }

  if (dropdownErrors?.includes('DUPLICATED_OPTION')) {
    return '동일한 옵션이 입력된 드롭다운이 있습니다.';
  }

  if (dropdownErrors?.includes('TOO_MANY_OPTION')) {
    return `드롭다운 옵션은 최대 ${MAX_OPTION_COUNT}개까지만 설정할 수 있습니다.`;
  }

  const dataLabelErrors = getFieldsDataLabelErrors(fields);

  if (dataLabelErrors?.includes('EMPTY_VALUE')) {
    return '입력되지 않은 데이터 라벨이 있습니다.';
  }

  if (dataLabelErrors?.includes('DUPLICATED_VALUE')) {
    return '중복된 데이터 라벨이 있습니다.';
  }

  const invalidWidthDropdowns = fields
    .filter((field): field is DropdownField => field.type === 'DROPDOWN')
    .filter((field) => {
      return field.size.width > 1;
    });

  if (invalidWidthDropdowns.length > 0) {
    return '문서 너비보다 긴 드롭다운이 있습니다.\n설정을 조정해 주세요.';
  }

  return null;
}
